import styled from '@emotion/styled'
import { color, fontSize, space } from '@ticketswap/solar'
import { createMarkup } from '~/utils/createMarkup'

const TermsAndConditions = styled.p`
  color: ${color.foregroundSubtle};
  font-size: ${fontSize[16]};
  text-align: center;
  margin-block-start: ${space[16]};

  a {
    color: ${color.foreground};
  }
`

const TermsAndConditionsLabel = ({ t }) => (
  <TermsAndConditions
    dangerouslySetInnerHTML={createMarkup(t('common:auth.login.info.terms'), {
      renderInline: true,
      openLinksInNewTab: true,
    })}
  />
)

export default TermsAndConditionsLabel
